import { TCOLOR_TO_SIZE_QUANTITES, TRESPONSE_PO_DETAILS_COLOR_SIZE } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';
import { TTableCellType, TTableOptions, TTextCell } from '../../table.type';

const createSizeHeaderRow = (colorToSizeData: TRESPONSE_PO_DETAILS_COLOR_SIZE): TTableOptions['headerConfig'] => {
  const headerRow = [
    ...colorToSizeData.sizes.map((sInfo) => {
      return {
        type: 'TEXT_CELL',
        text: sInfo,
        liftedInput: {
          input: {
            type: 'INPUT',
            subType: 'number',
            setValue: (v: TCOLOR_TO_SIZE_QUANTITES) => v.qty_by_size[sInfo],
          },
          metadata: {
            keyName: sInfo,
            isRequired: true,
          },
        },
      };
    }),
  ] as TTextCell[];
  return headerRow;
};

const getSizeQtyRows = (
  colorToSizeData: TRESPONSE_PO_DETAILS_COLOR_SIZE,
  rowItem: TRESPONSE_PO_DETAILS_COLOR_SIZE['color_to_size_wise_quantities'][number],
) => {
  const rows = [
    ...colorToSizeData.sizes.map((sInfo) => {
      return {
        type: 'TEXT_CELL',
        text: rowItem.qty_by_size[sInfo] || 0,
      };
    }),
  ] as TTableCellType[];
  return rows;
};

export const PO_EDIT_COLOR_SIZE_TABLE_MODEL = {
  createByRatioEditModel: (poColorSizeData: TRESPONSE_PO_DETAILS_COLOR_SIZE, isEditDisabled: boolean) => {
    return ModifiersZTableModel.createTableModel(
      poColorSizeData.color_to_size_wise_quantities,
      {
        isViewOnly: isEditDisabled,
        headerConfig: [
          {
            type: 'TEXT_CELL',
            text: 'COLOR',
            liftedInput: {
              input: {
                type: 'INPUT',
                subType: 'text',
                setValue: (v) => v.color,
              },
              metadata: {
                keyName: 'color',
                noEditsInTable: true,
              },
            },
          },
          {
            type: 'TEXT_CELL',
            text: 'CURRENT ORDER QTY',
            liftedInput: {
              input: {
                type: 'INPUT',
                subType: 'number',
                setValue: (v) => v.qty,
              },
              metadata: {
                keyName: 'current_qty',
                noEditsInTable: true,
              },
            },
          },
          {
            type: 'TEXT_CELL',
            text: 'NEW ORDER QTY',
            liftedInput: {
              input: {
                type: 'INPUT',
                subType: 'number',
                setValue: (v) => v.qty,
              },
              metadata: {
                keyName: 'qty',
                isRequired: true,
              },
            },
          },
        ],
      },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: [
            {
              type: 'TEXT_CELL',
              text: item.color,
            },
            {
              type: 'TEXT_CELL',
              text: item.qty,
            },
            {
              type: 'TEXT_CELL',
              text: item.qty,
            },
          ],
        };
      },
    );
  },
  createManualEditModel: (poColorSizeData: TRESPONSE_PO_DETAILS_COLOR_SIZE, isEditDisabled: boolean) => {
    return ModifiersZTableModel.createTableModel(
      poColorSizeData.color_to_size_wise_quantities,
      {
        ...(!isEditDisabled ? { edit: { hasAddRow: true, hasDeleteRow: false } } : {}),
        isViewOnly: isEditDisabled,
        headerConfig: [
          {
            type: 'TEXT_CELL',
            text: 'COLOR',
            liftedInput: {
              input: {
                type: 'INPUT',
                subType: 'text',
                setValue: (v) => v.color,
              },
              metadata: {
                keyName: 'color',
                noEditsInTable: false,
              },
            },
          },
          ...createSizeHeaderRow(poColorSizeData),
        ],
      },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: [
            {
              type: 'TEXT_CELL',
              text: item.color,
            },
            ...getSizeQtyRows(poColorSizeData, item),
          ],
        };
      },
    );
  },
};
